export default __webpack_public_path__ + "static/media/header.a8565a0f.png";